<template>
  <div class="rolemanage">
    <div class="toolbar">
      <div>
        <el-input placeholder="请输入角色名称....." v-model="keyword" class="input-with-select" maxlength="20">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div style="display: inline-block;float: right">
          <el-row>
            <el-button type="primary" icon="el-icon-plus" circle @click="addRole"></el-button>
          </el-row>
        </div>
      </div>
    </div>
    <div class="content_wrapper">
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID号"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          label="角色名称"
          align="center"
          prop="account"
          width="180">
        </el-table-column>
        <el-table-column
          label="真实姓名"
          align="center"
          prop="name"
          width="120">
        </el-table-column>

        <el-table-column
          label="角色"
          align="center"
          prop="roleName"
          width="200">
        </el-table-column>

        <el-table-column
          label="最近登录时间"
          align="center"
          prop="lastLoginTime"
          width="220">
        </el-table-column>
        <el-table-column
          label="账户状态"
          align="center"
          prop="status"
          width="120">
        </el-table-column>

        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button  type="text" size="small" @click="editRole(scope.row.id)">编辑</el-button>
            <el-button  type="text" size="small" @click="deleteRole(scope.row.id)">删除</el-button>
            <el-button  type="text" size="small" @click="authorizeIt(scope.row.id,scope.row.name)">授权</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 编辑框 -->
    <edit-role-dialog  v-model="roleDialogVisible" :id="id" @success="editSuccess"></edit-role-dialog>

    <!-- 编辑框 -->
    <authorize-role-dialog  v-model="authDialogVisible" :id="id" :name="name" @success="authorizeSuccess"></authorize-role-dialog>
  </div>
</template>
<script type="text/babel">
import editRoleDialog from './edit-dialog'
import authorizeRoleDialog from './authorize-dialog'

import {Message} from 'element-ui'
export default {
  components: {
    editRoleDialog: editRoleDialog,
    authorizeRoleDialog: authorizeRoleDialog
  },
  data () {
    return {
      keyword: '',
      id: 0,
      name: '',
      roleDialogVisible: false,
      authDialogVisible: false,
      tableData: [{
        id: 1,
        account: 'admin',
        name: '系统管理员',
        roleName: '系统管理员',
        status: '启用中',
        lastLoginTime: '2018-12-27 15:01:47'
      }]
    }
  },
  methods: {
    addRole () {
      this.id = 0
      this.roleDialogVisible = true
    },
    editRole (id) {
      this.id = id
      this.roleDialogVisible = true
    },
    authorizeIt (id, name) {
      this.id = id
      this.name = name
      this.authDialogVisible = true
    },
    editSuccess () {
      this.id = 0
      this.roleDialogVisible = false
      Message.success(this.SysConstant.success)
      this.loadTableData()
    },
    authorizeSuccess () {
      this.id = 0
      this.authDialogVisible = false
      Message.success(this.SysConstant.success)
      this.loadTableData()
    },
    // 加载表格数据
    loadTableData () {

    },
    deleteRole (id) {
      this.$confirminfo('删除之后不可还原，您确定删除？', async () => {
        // 删除
        try {
          // 具体操作
          // 提示操作成功
          Message.success(this.SysConstant.success)
        } catch (e) {
          Message.error(e && e.msg)
        }
      }, () => {
        // 取消
      }
      )
    }
  }
}
</script>
<style scoped>
  .rolemanage {
    padding: 15px 10px;
  }
  .rolemanage .toolbar{
    height: 40px;
    background-color: #ccc;
    margin: 2px;
    width: 100%;
  }

  .rolemanage .toolbar .el-select {
    width: 130px;
  }
  .rolemanage .toolbar .input-with-select{
    width: 400px;
  }
  .rolemanage .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;

  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/role-manage/index.vue